import {
  getClazzShareUser,
  setClazzShareUser,
  getClazzShareId,
  setClazzShareId
} from '@/utils/share'

export default {
  state: {
    expolreTab: 'clazz',
    wxJsUrl: '',
    clazzShareUser: getClazzShareUser(),
    clazzShareId: getClazzShareId(),
    userRaceProfile: null
  },
  mutations: {
    SET_EXPLORE_TAB: (state, tab) => {
      state.expolreTab = tab
    },
    SET_WX_JS_URL: (state, url) => {
      state.wxJsUrl = url
    },
    SET_CLAZZ_SHARE_FROM: (state, f) => {
      state.clazzShareUser = f
    },
    SET_CLAZZ_SHARE_ID: (state, clazzId) => {
      state.clazzShareId = clazzId
    },
    SET_USER_RACE_PROFILE: (state, userRaceProfile) => {
      state.userRaceProfile = userRaceProfile
    }
  },
  actions: {
    SetClazzShare ({ commit, state }, share) {
      commit('SET_CLAZZ_SHARE_FROM', share.user)
      commit('SET_CLAZZ_SHARE_ID', share.clazz)
      setClazzShareUser(share.user)
      setClazzShareId(share.clazz)
    },
    SetUserRaceProfile ({ commit, state }, userRaceProfile) {
      commit('SET_USER_RACE_PROFILE', userRaceProfile)
    }
  }
}
